import React, { FC, useState, useRef, useEffect } from "react";
import {
  Container,
  NavWrapper,
  HeadWrapper,
  RightHeadContainer,
  ClientName,
} from './styles'
import { useTranslation } from "react-i18next";
import { Route, Navigate, Routes, useNavigate, useLocation, useParams } from "react-router-dom";
import { BackArrow, Button, Tabs, TopProgress } from "../../../components";
import {
  Users,
  Details
} from './components'
import { useUi } from "../../../context/ui.context";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { clientService } from "../../../api";
import { useAuth } from "../../../context/user.context";
import EditClient from "../client-edit";
import { permissionSurfaces, tabPermissionSurfaces, usePermission, usePermissionDecision } from '../../../permissions';

const ClientPage:FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<string>('1')
  const location = useLocation()
  const {setClientToInvite} = useAuth()
  const { mergeEntityPermissions } = usePermission()
  const canEditClient = usePermissionDecision(permissionSurfaces.detailActions.clientEdit).allowed
  const canViewDetails = usePermissionDecision(tabPermissionSurfaces.clientDetails).allowed
  const canViewUsers = usePermissionDecision(tabPermissionSurfaces.clientUsers).allowed
  const tabs = [
    {
      title:t("DETAILS"),
      slug:'details',
      id:'1',
      visible: canViewDetails,
    },
    {
      title:t("USERS"),
      slug:'users',
      id:'2',
      visible: canViewUsers,
    },
  ]
  const visibleTabs = tabs.filter((tab) => tab.visible)
  const defaultTab = visibleTabs[0]?.slug
  useEffect(() => {
    visibleTabs.map((item:any) => {
      if(location.pathname.includes(item.slug)){
        setActiveTab(item.slug)
      }
    })
  },[location, visibleTabs])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const { id } = useParams();
  const [client, setClient] = useState<any>()
  const {viewAlert} = useUi()
  useEffect(() => {
    if(id){
      clientService.getClient(id)
      .then((res) => {
        mergeEntityPermissions('clients', res.data, `Merged client ${id} detail permissions`)
        setClient(`${res.data.first_name} ${res.data.last_name}`)
        setClientToInvite(res.data)
      })
      .catch((e) => {
        if(e?.response?.data?.detail){
          viewAlert({
            severity:'error',
            message:e?.response?.data?.detail
          })
        }
      })
      .finally(() => {
        setPageLoading(false)
      })
    }
    return () => {
      setClientToInvite(undefined)
    }
  },[id, mergeEntityPermissions, setClientToInvite])
  if (!defaultTab) {
    return <Navigate replace to="/403" />
  }
  return(
    <Container>
      {/* <TopProgress/> */}
      {pageLoading ? null :
        <>
          <BackArrow onClick={() => navigate('/clients')} title={t("BACK_TO_CLIENTS")}/>
          <HeadWrapper>
            <ClientName>
              {client}
            </ClientName>
            {canEditClient ? (
              <Button
                variant='primary'
                size='small'
                title={t("EDIT")}
                onClick={() => navigate(`/clients/${id}/client-edit`)}
              />
            ) : null}
          </HeadWrapper>
          <NavWrapper>
            <div>
              <Tabs
                tabs={visibleTabs}
                size='display'
                location={activeTab}
                onChange={setActiveTab}
              />
            </div>
          </NavWrapper>
        </>
      }
      <Routes>
        <Route path="/" element={<Navigate replace to={defaultTab} />} /> 
        {canViewDetails && <Route path='/details' element={<Details/>}/>} 
        {canViewUsers && <Route path='/users' element={<Users/>}/>} 
        <Route path='*' element={<Navigate replace to={defaultTab} />} />
        {/* <Route path='/client-edit' element={<EditClient/>}/> */}
      </Routes>
    </Container>
  )
}

export default ClientPage
